@if (hasActivities) {
    <wm-mini-horizontag-stack-chart [items]="chartItems"></wm-mini-horizontag-stack-chart>
} @else {
    <div class="no-activities">
        No activities
    </div>
}
